export default {
  mounted() {
    this.$store.commit('bootstate/page_loaded')
  }
}
